// S5f-a C3 item 3 — the marker is a truthy OBJECT in JavaScript, so
// `${fin.simple_payback_years} yr` renders "[object Object] yr" and nothing
// throws. Every read of a comparison leaf goes through these helpers.
//
// Copy mirrors backend/comparison_copy.py. One author per language.

export const COMPARISON_COPY = {
  not_scored: {
    en: {
      long:
        "No diesel-only cost comparison was produced for this configuration. Cost savings, payback and return figures are therefore not shown.",
      short: "Not compared",
    },
    fr: {
      long:
        "Aucune comparaison de coûts avec une solution diesel seule n'a été produite pour cette configuration. Les économies, le retour sur investissement et les indicateurs de rentabilité ne sont donc pas affichés.",
      short: "Non comparé",
    },
  },
  unprintable: {
    en: {
      long:
        "The cost comparison, savings and return figures for this configuration are not included in this version of the report.",
      short: "Not included in this version",
    },
    fr: {
      long:
        "La comparaison des coûts, les économies et les indicateurs de rentabilité pour cette configuration ne sont pas inclus dans cette version du rapport.",
      short: "Non inclus dans cette version",
    },
  },
};

export function isNotScored(v) {
  return (
    v === null ||
    v === undefined ||
    (typeof v === "object" && v.state === "not_determined")
  );
}

export function comparisonShort(lang = "en", state = "not_scored") {
  const variants = COMPARISON_COPY[state] || COMPARISON_COPY.not_scored;
  return (variants[lang] || variants.en).short;
}

export function comparisonLong(lang = "en", state = "not_scored") {
  const variants = COMPARISON_COPY[state] || COMPARISON_COPY.not_scored;
  return (variants[lang] || variants.en).long;
}

// A payback in years, or the short copy when nothing was compared.
export function comparisonYears(v, lang = "en") {
  if (isNotScored(v)) return comparisonShort(lang);
  return lang === "fr" ? `${String(v).replace(".", ",")}\u00a0ans` : `${v} yr`;
}

// A money figure through the caller's formatter, or the short copy.
export function comparisonMoney(v, fmt, lang = "en") {
  if (isNotScored(v)) return comparisonShort(lang);
  return fmt ? fmt(v) : String(v);
}

// A raw value for charts / diffs: null when nothing was compared, so a
// numeric widget never receives an object.
export function comparisonValue(v) {
  return isNotScored(v) ? null : v;
}

// a37 — the long no-comparison copy names its reason (mirrors report_v3 no_comparison_long_*).
const NO_COMPARISON_REASON = {
  nodiesel: {
    en: "This site can't use diesel as a regular supply, so there is no diesel-only plant to compare it with. Cost savings, payback and return figures are therefore not shown.",
    fr: "Ce site ne peut pas utiliser le diesel comme approvisionnement régulier\u00a0: il n'existe donc pas de centrale 100\u00a0% diesel à laquelle le comparer. Les économies, le retour sur investissement et les indicateurs de rentabilité ne sont donc pas affichés.",
  },
  adjusted: {
    en: "You set this plant's sizes yourself, so it was not costed against a diesel-only plant. Cost savings, payback and return figures are therefore not shown.",
    fr: "Vous avez fixé vous-même les tailles de cette centrale\u00a0: elle n'a donc pas été chiffrée par rapport à une centrale 100\u00a0% diesel. Les économies, le retour sur investissement et les indicateurs de rentabilité ne sont donc pas affichés.",
  },
};

export function noComparisonLong(lang = "en", { adjusted = false, dieselAvailability = "available" } = {}) {
  const d = String(dieselAvailability || "available").toLowerCase();
  const key = adjusted ? "adjusted" : (d === "none" || d === "constrained") ? "nodiesel" : null;
  if (!key) return comparisonLong(lang);
  return NO_COMPARISON_REASON[key][lang] || NO_COMPARISON_REASON[key].en;
}
